/*
 * topical-prescription-product (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { topicalPrescriptionProducts } from "./topical-prescription-product.schema"

/* Select */
export type TopicalPrescriptionProduct = z.infer<typeof selectTopicalPrescriptionProductSchema>
export const selectTopicalPrescriptionProductSchema = createSelectSchema(topicalPrescriptionProducts)

/* Filters */
export type TopicalPrescriptionProductFilters = z.infer<typeof topicalPrescriptionProductFiltersSchema>
export const topicalPrescriptionProductFiltersSchema = z.object({
	id:                      z.string().optional(),
	topicalPrescriptionId:   z.string().optional(),
	productId:               z.string().optional(),
	active:                  z.boolean().optional(),
})

/* Create */
export const createTopicalPrescriptionProductSchema = createInsertSchema(topicalPrescriptionProducts)
	.partial(globalCreateExclude)
export type CreateTopicalPrescriptionProduct = z.infer<typeof createTopicalPrescriptionProductSchema>

/* Update */
export const updateTopicalPrescriptionProductSchema = createInsertSchema(topicalPrescriptionProducts)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateTopicalPrescriptionProduct = z.infer<typeof updateTopicalPrescriptionProductSchema>
